import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CashReceiptSectionProps } from "../../components/types";
import { checkProgressStatus } from "../utils";
import { usePartnerNavigate } from "src/api/hooks/usePartnerNavigate";

// 현금영수증 섹션 컴포넌트
// 현금영수증 발행 정보와 관련된 UI를 표시하는 컴포넌트
export const CashReceiptSection = ({
  recentBill,
  documentProofRequest,
  cashBillList,
  paymentAgree,
  setPaymentAgree,
  proofError,
  setDocumentProofRequest,
  setCashErrorFlags,
  handleClickExpenseProofCashBill,
}: CashReceiptSectionProps) => {
  // URL 파라미터에서 계약 ID 가져오기
  const { contractId } = useParams();
  const navigate = usePartnerNavigate();
  const { t } = useTranslation("contract");

  return (
    <section className="base-section-layout top-divider my-page-cashbill">
      <div className="base-section-layout__container">
        <div className="base-section-layout__wrap mb30 pb0">
          {/* 섹션 제목 */}

          <div className="base-section-layout__title-wrap">
            <h2>{t("detail.cashReceiptIssuance")}</h2>
          </div>
          {/* 현금영수증 발행 상태 표시 */}
          <div className="base-section-layout-line">
            <p className="base-section-layout-index text-primary3">{t("detail.issuance")}</p>
            {cashBillList.length > 0 ? (
              cashBillList.map((cash: any, index: number) => (
                <p className="base-section-layout-value" key={index}>
                  {checkProgressStatus(cash.progressStatus)}
                </p>
              ))
            ) : (
              <p className="base-section-layout-value">{t("detail.cashReceiptStatus.pending")}</p>
            )}
          </div>

          {/* 거래 유형 표시 */}
          <div className="base-section-layout-line">
            <p className="base-section-layout-index text-primary3">{t("detail.transactionType.label")}</p>
            <p className="base-section-layout-value">
              {documentProofRequest?.tradeUsage === "INCOME"
                ? documentProofRequest?.identityType === "MOBILE_NUM"
                  ? t("detail.transactionType.personalMobile")
                  : t("detail.transactionType.personalCard")
                : documentProofRequest?.identityType === "MOBILE_NUM"
                ? t("detail.transactionType.businessMobile")
                : documentProofRequest?.identityType === "CORP_NUM"
                ? t("detail.transactionType.businessNumber")
                : t("detail.transactionType.businessCard")}
            </p>
          </div>

          {/* 신분증 번호/카드번호 표시 */}
          <div className="base-section-layout-line">
            <p className="base-section-layout-index text-primary3">
              {documentProofRequest?.tradeUsage === "INCOME" ? t("detail.mobileOrCardNumber") : t("detail.businessNumberOrCardNumber")}
            </p>
            <p className="base-section-layout-value">{documentProofRequest?.identityNum}</p>
          </div>

          {/* 현금영수증 발급 정보 수정 버튼 */}
          {(cashBillList.length === 0 || cashBillList[0].progressStatus === "TRANS_READY" || cashBillList[0].progressStatus === "TEMP_SAVE") && (
            <>
              <div className="base-floating-btn-wrap px0">
                <button
                  type="button"
                  className="base-btn color-white base-btn-cashbill"
                  onClick={() => {
                    navigate(`/court/mypage/contracts/${contractId}/CashBillInfoEdit`);
                  }}
                >
                  {t("detail.editIssuanceInformation")}
                </button>
              </div>
            </>
          )}
        </div>
      </div>

      {/* 현금영수증 제출 버튼 (주석 처리됨) */}
      {/* <CashReceiptSubmitButton
        paymentAgree={paymentAgree}
        setPaymentAgree={setPaymentAgree}
        documentProofRequest={documentProofRequest}
        handleClickExpenseProofCashBill={handleClickExpenseProofCashBill}
      /> */}
    </section>
  );
};
